import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '2 - 3x5, 8 - 1x2',
  imageCount: 10,
  displayGroup: 'DG_3X5_WALLET',
  calc: (height) => {
    const psWidth = height / ASPECT_RATIO / 4;
    const psHeight = height / 4;
    const plWidth = height / ASPECT_RATIO / 2;
    const plHeight = height / 2;

    return {
      gridTemplate: `
        'p1 p2 p9' ${psHeight}px
        'p3 p4 p9' ${psHeight}px
        'p5 p6 p10' ${psHeight}px
        'p7 p8 p10' ${psHeight}px
        / ${psWidth}px ${psWidth}px ${plWidth}px`,
      photos: [...gridPhotos(1, 8, psWidth, psHeight), ...gridPhotos(9, 10, plWidth, plHeight)]
    };
  }
};
